module.exports = __webpack_public_path__ + "static/media/icon_check_circle.30adc56e.svg";